import React from 'react';
import '../App.css';
import { useHistory, Link } from 'react-router-dom';
import ReactZondicons from 'react-zondicons';
import { useAuth } from '../contexts/Auth';
import { useTranslation } from 'react-i18next';

class NavContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };

    // This binding is necessary to make `this` work in the callback
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState(state => ({
      isOpen: !state.isOpen
    }));
  }
  render() {
    let menuIcon, menuCssClass;
    if (this.state.isOpen) {
      menuIcon = <ReactZondicons.Close />;
      menuCssClass = 'block';
    } else {
      menuIcon = <ReactZondicons.Menu />;
      menuCssClass = 'hidden';
    }

    return (
      <header className="bg-blue-500 sm:flex sm:justify-between sm:px-4 sm:py-3">
        <div className="flex items-center justify-between px-4 py-3 sm:p-0">
          <div>
            <span className="font-semibold text-xl tracking-tight">
                <Link to="/">
                  <span className='flex flex-row'>
                    <img src="logo512.png" alt="" />
                    Chit Tracker
                  </span>
                </Link>
              </span>
          </div>
          <div className="sm:hidden">
            <button className="block text-gray-700 hover:text-gray-300 focus:text-white" onClick={this.handleClick}>
              {menuIcon}
            </button>
          </div>
        </div>
        <div className={`px-2 pt-2 pb-4 sm:flex ${menuCssClass}`}>
          <div className="sm:flex">
            {Object.keys(this.props.lngs).map((lng) => (
              <button className={"block px-2 py-1 text-gray-900 hover:text-gray-400 hover:bg-blue-800 rounded-full " + (this.props.i18n.resolvedLanguage === lng ? 'bg-gray-400' : '')} key={lng} type="submit" onClick={() => this.props.i18n.changeLanguage(lng)}>
                {this.props.lngs[lng].nativeName}
              </button>
            ))}</div>
          {
            !this.props.user ?
              <div className="sm:flex">
                <Link className="block px-2 py-1 text-gray-900 font-semibold hover:text-gray-400 hover:bg-blue-800" to="/signup">
                  {this.props.t('button.signup')}
                </Link>
                <Link className="block px-2 py-1 text-gray-900 font-semibold hover:text-gray-400 hover:bg-blue-800" to="/login">
                  {this.props.t('button.login')}
                </Link>
              </div> :
              <div className="sm:flex">
                <Link className="block px-2 py-1 text-gray-900 font-semibold hover:text-gray-400 hover:bg-blue-800" to="/completed">
                  {this.props.t('button.completedChits')}
                </Link>
                <Link className="block px-2 py-1 text-gray-900 font-semibold hover:text-gray-400 hover:bg-blue-800" to="/user">
                  {this.props.t('button.profile')}
                </Link>
                <button className="block px-2 py-1 text-gray-900 font-semibold hover:text-gray-400 hover:bg-blue-800" onClick={this.props.handleSignOut}>
                  {this.props.t('button.signout')}
                </button>
              </div>
          }
          <Link className="block px-2 py-1 text-gray-900 font-semibold hover:text-gray-400 hover:bg-blue-800" to="/about">
            {this.props.t('button.about')}
          </Link>
        </div>
      </header>
    );
  }
}

export default function Nav(props) {
  // Get current user and signOut function from context
  const { user, signOut } = useAuth()

  const history = useHistory()

  async function handleSignOut() {
    // Ends user session
    await signOut()

    // Redirects the user to Login page
    history.push('/login')
  }

  let lngs = props.languages;
  let i18n = props.i18n;

  const { t } = useTranslation();

  return (
    <div>
      <NavContent user={user} handleSignOut={handleSignOut} lngs={lngs} i18n={i18n} t={t} />
    </div>
  )
}
